import {
  AttributionEvidenceType,
  MAX_ATTRIBUTION_WINDOW_DAYS,
} from "@redotech/redo-attribution-common/attribution-settings";
import * as z from "zod";

/** The marketing analytics page's attribution filters. Each omitted one keeps
 *  the team's saved setting. */
export const analyticsAttributionInput = {
  attributionDays: z
    .number()
    .min(1)
    .max(MAX_ATTRIBUTION_WINDOW_DAYS)
    .optional(),
  attributionEvidence: z.array(z.enum(AttributionEvidenceType)).optional(),
  /** Whether bot clicks count, as clicks and as attribution evidence. */
  includeBotClicks: z.boolean().optional(),
};
